import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Checkbox, MenuItem, TextField, Tooltip } from "@mui/material";
import MaterialTable, { MTableAction } from "material-table";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";
import {
  AddECMSComponentsAction,
  DeleteECMSComponentsAction,
  GetECMSComponentsAction,
  UpdateECMSComponentsAction,
} from "../../../../../store/Finance/EcmsComponents/Action";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import { GetEmployeesAction } from "../../../../../store/Employee/Employee/Action";

const EcmsComponentsGrid = () => {
  const dispatch = useDispatch();
  const { isLoadingEcmsComp, ecms_components_data } =
    useSelector((state) => state.FinanceReducer?.EcmsConfigFinanceReducer);
  const { employees_options } = useSelector(
    (state) => state.EmployeeReducer.EmployeesReducer
  );

  const mappedData = (ecms_components_data || [])?.map((item) => ({
    ...item,
    label: item?.ecms_adjustments_configuration_json?.label || "",
    component_type: item?.ecms_adjustments_configuration_json?.component_type || "",
    approver_id: {
      employee_id: item?.ecms_adjustments_configuration_json?.approver_id,
      name: item?.ecms_adjustments_configuration_json?.approver_name,
    },
  }));
 
  const [employeesData, setEmployeesData] = useState({
    load: true,
    values: [],
  });
  useEffect(() => {
    dispatch(GetECMSComponentsAction());
    dispatch(GetEmployeesAction({ is_active: true }));
  }, [dispatch]);

  useEffect(() => {
  if (employees_options?.length) {
    setEmployeesData({
      load: false,
      values: employees_options?.filter(
        (el) =>
          el?.core_hr_user_type === "Owner" ||
          el?.core_hr_user_type === "Admin"
      ),
    });
  }
  }, [employees_options]);
  return (
    <Box>
      <MaterialTable
        isLoading={isLoadingEcmsComp}
        columns={[
          {
            title: "Title",
            cellStyle: { padding: "0px 10px 0px 13px" },
            field: "label",
            validate: (rowData) => {
              if (rowData?.tableData && rowData?.tableData?.editing === "delete") {
                  return ""; 
                }
                if (!rowData?.label?.trim()) {
                  return "Title cannot be empty";
                }

                return "";
            },
            editComponent: (props) => {
              return (
                <Box sx={{ width: "70%" }}>
                  <TextField
                    required={true}
                    variant="standard"
                    fullWidth
                    value={props?.value}
                    onChange={(e) => props.onChange(e.target.value)}
                  />
                </Box>
              );
            },
          },
          {
            title: "Type",
            cellStyle: { padding: "0px 10px 0px 13px" },
            field: "component_type",
            validate: (rowData) => {
              if (rowData?.tableData && rowData?.tableData?.editing === "delete") {
                  return ""; 
                }
              if (!rowData?.component_type) {
                return "Type cannot be empty";
              }
              return "";
            },
            render: (rowData) => {
              const type = rowData?.component_type;
              return type === "earning"
                ? "Earning"
                : type === "deduction"
                ? "Deduction"
                : "";
            },
            editComponent: (props) => {
              return (
              <Box sx={{ width: "50%" }}>
                <TextField
                  select
                  required
                  fullWidth
                  variant="standard"
                  value={props?.value || ""}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    props.onChange(newValue);
                    if (newValue === "deduction") {
                      props.rowData.taxable_flag = false;
                      props.onRowDataChange({
                        ...props.rowData,
                        component_type: newValue,
                        taxable_flag: false,
                      });
                    }
                  }}
                >
                  <MenuItem value="earning">Earning</MenuItem>
                  <MenuItem value="deduction">Deduction</MenuItem>
                </TextField>
              </Box>
            )},
          },
          {
            title: "Is Taxable",
            cellStyle: { padding: "0px 10px 0px 15px" },
            field: "taxable_flag",
            render: (rowData) => (rowData?.taxable_flag ? "Yes" : "No"),
            editComponent: (props) => {
              const isDeduction = props.rowData?.component_type === "deduction";
              return (
               <Tooltip
                  title={isDeduction ? "Deductions are not taxable" : ""}
                  placement="top"
                >
                  <span>
                    <Checkbox
                      checked={Boolean(props?.value)}
                      onChange={(e) => props.onChange(e.target.checked)}
                      inputProps={{ "aria-label": "Taxable Checkbox" }}
                      disabled={isDeduction}
                    />
                  </span>
                </Tooltip>
            )},
          },
          {
            title: "Approver",
            headerStyle: { textAlign: "start", paddingLeft: "2%" },
            cellStyle: { textAlign: "start", padding: "10px 0px 0px 2%" },
            field: "approver_id",
            grouping: false,
            render: (rowData) => rowData.approver_id?.name,
            validate: (rowData) => {
              if (
                rowData?.tableData &&
                rowData?.tableData?.editing === "delete"
              ) {
                return "";
              }
              if (!rowData?.approver_id) {
                return "Approver cannot be empty";
              }
              return "";
            },
            editComponent: (props) => (
              <Box sx={{ width: "95%" }}>
                <SelectableSearch
                  fullWidth
                  required
                  variantType="standard"
                  size="small"
                  loading={() => {}}
                  value={props.value || ""}
                  fieldLabel="name"
                  name="employee_id"
                  onChangeEvent={(e, v) => {
                    props.onChange(v);
                  }}
                  data={employeesData}
                />
              </Box>
            ),
          },
        ]}
        data={mappedData}
        icons={{
          Add: () =>( 
            <Button
                variant="contained" 
                className="mpl-primary-btn"
                style={{ minWidth: 0,width: "82px",height:"35px", padding: "2px 12px", textTransform: "none" }}
                startIcon={<AddIcon />}
              >
                Add
            </Button>
            ),
          Edit: (props) => <EditIcon sx={{color: props?.disabled ? "#bdbdbd" : "#637381"}} />,
          Delete: (props) => <DeleteIcon sx={{ color: props?.disabled ? "#bdbdbd" : "#637381"}} />,
        }}
        editable={{
          onRowAdd: (newRow) =>
            new Promise((resolve, reject) => {
              if (!newRow?.label?.trim()) {
                return reject();
              }
              if (!newRow?.component_type) {
                return reject();
              }
              if (!newRow?.approver_id?.employee_id) {
                return reject();
              }
              dispatch(
                AddECMSComponentsAction({
                  ...newRow,
                  ecms_adjustments_configuration_json: JSON.stringify(
                    {
                      label: newRow?.label,
                      component_type: newRow?.component_type,
                      name: newRow?.label?.toLowerCase()?.replace(/ /g, "_"),
                      approver_id: newRow?.approver_id?.employee_id,
                      approver_name: newRow?.approver_id?.name
                    }
                  ),
                })
              );
              setTimeout(() => resolve(), 500);
            }),
          isEditable: rowData => !rowData?.is_utilised,
          isDeletable: rowData => !rowData?.is_utilised,
          onRowUpdate: (newRow, oldRow) =>
            new Promise((resolve, reject) => {
              if (!newRow?.label?.trim()) {
                return reject();
              }
              if (!newRow?.component_type) {
                return reject();
              }
              dispatch(UpdateECMSComponentsAction({
                ...newRow,
                ecms_adjustments_configuration_json: JSON.stringify(
                    {
                      label: newRow?.label,
                      component_type: newRow?.component_type,
                      name: newRow?.label?.toLowerCase()?.replace(/ /g, "_"),
                      approver_id: newRow?.approver_id?.employee_id,
                      approver_name: newRow?.approver_id?.name
                    },
                  ),
              }));
              setTimeout(() => resolve(), 500);
            }),
          onRowDelete: (selectedRow) =>
            new Promise((resolve, reject) => {
              dispatch(
                DeleteECMSComponentsAction({
                  ...selectedRow,
                })
              );
              setTimeout(() => resolve(), 1000);
            }),
        }}
        options={{
          maxBodyHeight: 220,
          minBodyHeight: 220,
          rowStyle: { fontSize: "13px" },
          headerStyle: { padding: "5px 10px 5px 13px", fontWeight: "bold" },
          sorting: false,
          search: false,
          searchFieldAlignment: "right",
          searchAutoFocus: true,
          searchFieldVariant: "standard",
          filtering: false,
          paging: false,
          selection: false,
          actionsColumnIndex: -1,
          grouping: false,
          addRowPosition: "first",
        }}
         components={{
              Action: (props) => {
                  const ActionComponent = props?.components?.Action || MTableAction;

                  if (props?.action?.icon && typeof props?.action?.icon === "function") {
                      return (
                      <Box
                          sx={{
                          "& .MuiIconButton-root": {
                              "&:hover": {
                              backgroundColor: "transparent",
                              },
                          },
                          }}
                      >
                          <ActionComponent {...props} />
                      </Box>
                      );
                  
                  }
                  return <ActionComponent {...props} />;
              },
          }}
        title=""
      />
    </Box>
  );
};
export default EcmsComponentsGrid;
